import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { WebsiteButtonInterface } from 'src/shared/types/entities/website-button-interface'
import { BaseEditorButton } from '../base-editor-button'

export interface WebsiteButtonProps {
  entity: WebsiteButtonInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const WebsiteButton = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: WebsiteButtonProps) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <BaseEditorButton entity={entity}></BaseEditorButton>
    </BaseEntityNew>
  )
}
